import { DocumentCheckIcon, LockClosedIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

import { PlanSectionCard } from '../../molecules/PlanSectionCard';

/**
 * Aba "Documentos de Convênio".
 *
 * Renderiza estado explícito de indisponibilidade e **não dispara requisição**:
 * não existe endpoint de listagem, download ou aprovação desses documentos.
 *
 * Deliberadamente não exibe uma tabela vazia como o legado faz. Tabela vazia
 * seria indistinguível de "este plano não tem documentos pendentes", que é
 * justamente a informação que a tela não pode dar — o contrato pedido ao backend
 * está no painel de spec do `design/payment.pen`.
 */
export function PlanAgreementDocsTab() {
  const { t } = useTranslation('individualPayment');

  return (
    <PlanSectionCard title={t('planEdit.documents.title')} icon={DocumentCheckIcon}>
      <div className="flex flex-col items-center gap-micro px-micro py-md text-center">
        <span className="flex items-center justify-center rounded-pill bg-base-gray-100 p-micro">
          <LockClosedIcon className="h-xxs w-xxs text-base-gray-700" />
        </span>
        <p className="ts-heading-xs text-ctx-content-title">
          {t('planEdit.documents.unavailableTitle')}
        </p>
        <p className="max-w-[36rem] ts-paragraph-xs text-ctx-content-placeholder">
          {t('planEdit.documents.unavailableHint')}
        </p>
      </div>
    </PlanSectionCard>
  );
}
